import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Nav,
  Navbar,
  NavDropdown,
  MenuItem,
  Tabs,
  ButtonToolbar,
  Button,
  Table,
  ButtonGroup,
  Row,
  Col,
  Grid,
  Panel,
  FormGroup,
  FormControl
} from "react-bootstrap";
import { compose, withProps, withStateHandlers } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";
import { Icon, Card, Dropdown } from "semantic-ui-react";
import ReactGA from "react-ga";
import Pagination from "react-js-pagination";
import moment from "moment";

import Sidebar from "../../Sidebar/Sidebar";
import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";
import OSCard from "../../OSCard/OSCard";
import OSDayCard from "../../OSDayCard/OSDayCard";

import { translate, getLanguage } from "../../Translation/Translation";
import { FETCH_URL } from "../../../utilities";

const props_json = {
  display: "inline-block",
  margin: "15px",
  width: "223px",
  verticalAlign: "top",
  border: "1px solid rgb(116,135,157) "
};

const propsouter_json = {
  // height: '300px',
  display: "inline-block"
};

const img_json = {
  width: "100%",
  height: "200px",
  cursor: "pointer"
};

const places = {
  fontSize: "16px",
  fontWeight: "bold",
  color: "rgb(41,63,84)",
  display: "block"
};

const pd_spaces = {
  padding: "10px",
  borderTop: "1px solid rgb(116,135,157) "
};

const exp_text = {
  color: "rgb(41,63,84)",
  fontSize: "14px"
};

const MapWithAMakredInfoWindow = compose(
  withStateHandlers(
    () => ({
      isOpen: false
    }),
    {
      onToggleOpen: ({ isOpen }) => () => ({
        isOpen: !isOpen
      })
    }
  ),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap
    defaultZoom={10}
    defaultCenter={{ lat: 36.3931562, lng: 25.4615092 }}
    defaultOptions={{
      styles: [
        {
          featureType: "all",
          elementType: "labels.text.fill",
          stylers: [{ saturation: 36 }, { color: "#333333" }, { lightness: 40 }]
        },
        {
          featureType: "all",
          elementType: "labels.text.stroke",
          stylers: [
            { visibility: "on" },
            { color: "#ffffff" },
            { lightness: 16 }
          ]
        },
        {
          featureType: "all",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }]
        },
        {
          featureType: "administrative",
          elementType: "geometry.fill",
          stylers: [{ color: "#fefefe" }, { lightness: 20 }]
        },
        {
          featureType: "administrative",
          elementType: "geometry.stroke",
          stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }]
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [{ color: "#f6f6f6" }, { lightness: "-11" }]
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [{ color: "#f5f5f5" }, { lightness: 21 }]
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [{ color: "#dedede" }, { lightness: 21 }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [{ color: "#ffffff" }, { lightness: 17 }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }]
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: "-10" }]
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: "-12" }]
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [{ visibility: "off" }]
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [{ color: "#693b1d" }, { lightness: 19 }]
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            { color: "#e9e9e9" },
            { lightness: "-47" },
            { saturation: "0" }
          ]
        }
      ]
    }}
  >
    <Marker
      position={{ lat: 36.3931562, lng: 25.4615092 }}
      onClick={props.onToggleOpen}
    >
      {props.isOpen && (
        <InfoWindow onCloseClick={props.onToggleOpen}>
          <div>
            This is just some info for Egina.<br /> Please add more if you like.
          </div>
        </InfoWindow>
      )}
    </Marker>
  </GoogleMap>
));

class AllEventsContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      all: [],
      events: [],
      events2: [],
      eventstype: [],
      departure: [],
      activeOutPage: 1,
      activeInPage: 1,
      loading: false
    };
  }

  handlePageChangeIn = pageNumber => {
    this.setState({ activeInPage: pageNumber });
  };

  handlePageChangeOut = pageNumber => {
    this.setState({ activeOutPage: pageNumber });
  };

  fetchDeparture = () => {
    fetch(
      `${FETCH_URL}/proxy.php?ws=358831c718affbe0536608ebd7b8572a/${getLanguage()}`,
      {
        method: "GET"
      }
    )
      .then(response => response.json())
      .then(responseJson => {
        this.setState({ departure: responseJson });
        return responseJson;
      })
      .catch(error => {
        console.error(error);
      });
  };

  fetchEventsType = () => {
    fetch(
      `${FETCH_URL}/proxy.php?ws=b71b5e097b885d9929e72f88b07361ee/${getLanguage()}`,
      {
        method: "GET"
      }
    )
      .then(response => response.json())
      .then(responseJson => {
        this.setState({ eventstype: responseJson });
        return responseJson;
      })
      .catch(error => {
        console.error(error);
      });
  };

  fetchEvents(locationCode, eventTypeId, maxEventsSize, date) {
    fetch(
      `${FETCH_URL}/proxy.php?ws=3624a2d36f2aa7035e6160b3997480d8`,
      {
        method: "POST",
        body: JSON.stringify({
          languageCode: `${getLanguage()}`,
          locationCode: locationCode,
          eventTypeId: eventTypeId,
          maxEventsSize: maxEventsSize,
          date: date
        })
      }
    )
      .then(response => response.json())
      .then(responseJson => {
        this.setState({ events: responseJson.events });
        return responseJson;
      })
      .catch(error => {
        console.error(error);
      });
  }
  componentDidMount() {
    //setTimeout(() => this.setState({ loading: false }), 500);
    this.fetchDeparture();
    this.fetchEventsType();
    this.fetchEvents(
      this.props.events.locationCode,
      this.props.events.eventTypeId,
      this.props.events.maxEventsSize,
      this.props.events.date
    );
  }

  eventsTypeChanged = target => {
    let newdate = new Date();
    if (this.props.events.eventTypeId != target.value) {
      this.fetchEvents(
        this.props.events.locationCode,
        target.value,
        this.props.events.maxEventsSize,
        this.props.events.date
      );
      this.props.setTypeId(target.value);
      this.state.activeOutPage = 1;
    }

    if ((this.state.events.length = 0)) {
    }

    ReactGA.event({
      category: "Events",
      action: "searchSpecificEvent(with TypeID)",
      label: `${moment(newdate).format("YYYYMMDD")}#${moment(newdate).format(
        "hhmm"
      )}#0#${target.value}#2b735297-625f-412f-8bd0-6a6498d494e0`
    });
  };

  placeChanged = target => {
    let newdate = new Date();
    if (this.props.events.locationCode != target.value) {
      this.fetchEvents(
        target.value,
        this.props.events.eventTypeId,
        this.props.events.maxEventsSize,
        this.props.events.date
      );
      this.props.setLocationCode(target.value);
    }
    if ((this.state.events.length = 0)) {
    }

    ReactGA.event({
      category: "Events",
      action: "searchSpecificEvent(with LocationID)",
      label: `${moment(newdate).format("YYYYMMDD")}#${moment(newdate).format(
        "hhmm"
      )}#${target.value}#0#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`
    });
  };

  render() {
    const { loading } = this.state;

    if (loading) {
      return null;
    }

    let departure = [];
    departure = this.state.departure.map(dep => {
      return { key: dep.id, text: dep.name, value: dep.code };
    });
    departure.unshift({
      key: 0,
      text: translate(getLanguage(), "All Destinations"),
      value: 0
    });

    let eventstype = [];
    eventstype = this.state.eventstype.map(type => {
      return { key: type.id, text: type.name, value: type.id };
    });
    eventstype.unshift({
      key: 0,
      text: translate(getLanguage(), "All Event Types"),
      value: 0
    });

    const events = this.state.events.map(event => {
      return (
        <Col xs={12} sm={6} lg={4} key={event.id}>
          <OSCard
            key={event.id}
            id={event.id}
            image={event.imageUrl}
            title={event.eventName}
            link={event.link}
            startDate={event.eventVenues[0].startDate}
            endDate={event.eventVenues[0].endDate}
            venueName={event.eventVenues[0].venueName}
            description={event.description}
            lat={event.eventVenues[0].latitude}
            lng={event.eventVenues[0].longitude}
          />
        </Col>
      );
    });

    return (
      <div>
        {this.state.events.length > 0 ? (
          <div>
            <Row
              style={{
                margin: "0px 0px 20px 0px",
                padding: "0px",
                textAlign: "center",
                background: "white",
                display: "block"
              }}
            >
              <Dropdown
                className="filterDrop"
                value={this.props.events.locationCode}
                style={{ margin: "0px 10px" }}
                placeholder={translate(getLanguage(), "All Destinations")}
                selection
                options={departure}
                onChange={(event, target) => this.placeChanged(target)}
              />
              <Dropdown
                className="filterDrop"
                value={this.props.events.eventTypeId}
                style={{ margin: "0px 10px" }}
                placeholder={translate(getLanguage(), "All Event Types")}
                selection
                options={eventstype}
                onChange={(event, target) => this.eventsTypeChanged(target)}
              />
            </Row>
            <Row style={{ margin: "0px", textAlign: "center" }}>{events}</Row>
          </div>
        ) : (
          <div>
            <Row
              style={{
                margin: "0px 0px 20px 0px",
                padding: "0px",
                textAlign: "center",
                background: "white",
                display: "block"
              }}
            >
              <Dropdown
                className="filterDrop"
                value={this.props.events.locationCode}
                style={{ margin: "0px 10px" }}
                placeholder={translate(getLanguage(), "All Destinations")}
                selection
                options={departure}
                onChange={(event, target) => this.placeChanged(target)}
              />
              <Dropdown
                className="filterDrop"
                value={this.props.events.eventTypeId}
                style={{ margin: "0px 10px" }}
                placeholder={translate(getLanguage(), "All Event Types")}
                selection
                options={eventstype}
                onChange={(event, target) => this.eventsTypeChanged(target)}
              /> 
            </Row>
            <Row
              className="loader"
              style={{ margin: "0px"}}
            >
              <h1>Events not Found</h1>

            </Row>
          </div>
        )}
      </div>
    );
  }
}

export default AllEventsContent;



// WEBPACK FOOTER //
// ./src/components/Pages/Allevents/AllEventsContent.js